import React, { useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import Call from "../../assets/images/icons/call.svg"
import Email from "../../assets/images/icons/email.svg"
import Whatsapp from "../../assets/images/icons/whatsapp.svg"
import RightArrow from "../../assets/images/icons/right_arrow.svg"

const GetInTouch = () => {
  const [menu, setMenu] = useState(false)

  return (
    <>
      <div className="get-in-touch-wrapper">
        <Dropdown isOpen={menu} toggle={() => setMenu(!menu)}>
          <DropdownToggle>Get In Touch</DropdownToggle>
          <DropdownMenu>
            {/* Submenu */}
            <UncontrolledDropdown direction="right">
              <DropdownToggle
                nav
                className="dropdown-item"
                style={{
                  position: "relative",
                }}
              >
                <img src={Call} alt="" height={"20px"} /> <span>Call Us</span>
                <div
                  style={{
                    position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  <img src={RightArrow} alt="" height={"12px"} />
                </div>
              </DropdownToggle>
              <DropdownMenu className="sub-nav">
                <DropdownItem>
                  <p>For Accounts Related Queries</p>
                  <div>
                    <a href="tel:'+919850032224">+91 98500 32224</a>
                  </div>
                </DropdownItem>
                <DropdownItem>
                  <p>For Technical & Other Support</p>
                  <div>
                    <a href="tel:'+918956779130">+91 89567 79130</a>
                  </div>
                  <div className="mt-1">
                    <a href="tel:'+918956779131">+91 89567 79131</a>
                  </div>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <DropdownItem>
              <img src={Whatsapp} alt="" height={"20px"} />
              <a
                href="https://wa.me/918956779130"
                target="_blank"
                rel="noreferrer"
              >
                Send Message
              </a>
            </DropdownItem>
            <DropdownItem>
              <img src={Email} alt="" height={"20px"} />
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=icd@prachay.com"
                target="_blank"
                rel="noopener noreferrer"
              > Send Email</a>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </>
  )
}

export default GetInTouch
